/*@flow*/
import * as I from 'immutable';
import { DEFAULT_STROKE_COLOR } from './constants';
import type { DistrictT } from './types';

const initDistrict = {
  id: null,
  name: '',
  geojson: '',
  color: DEFAULT_STROKE_COLOR,
  dashboardId: null,
};

const fn: I.RecordFactory<DistrictT> = I.Record(initDistrict);

export default fn;
